export const GET_UPLOADS = {
  REQUEST: "GET_UPLOADS",
  PENDING: "GET_UPLOADS_PENDING",
  FULFILLED: "GET_UPLOADS_FULFILLED",
  FAILED: "GET_UPLOADS_FAILED"
}

export const SET_SEARCH = 'SET_UPLOADS_SEARCH'